import {axiosService} from "../axios.service";
import {urls} from "../../constants";

const packsService = {
    getAllPack: () => axiosService.get(urls.settings.packs).then(value => value.data),
    createPack: (data) => axiosService.post(urls.settings.packs, data).then((value) => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.packs }/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.packs}/${id}`),
    changePricePack: (id, data) => axiosService.patch(`${urls.settings.packs}/price/${id}`, data).then((value) => value.data),
    changeActive: (id, data) => axiosService.patch(`${urls.settings.packs}/active/${id}`, data).then((value) => value.data),
};

export {
    packsService
}